import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { Link } from "react-router-dom";
import {
  useFetchCollegesQuery,
  useFetchGamesNewsQuery,
  useFetchProfilesQuery,
  useFetchSingleCustomAdvertiserQuery,
} from "../../store/api/apiSlice";
import FadeInAnimation from "../animations/FadeInAnimation";
import LeftSideAnimation from "../animations/LeftAndRightSideAnimation";
import RightSideNav from "../rightside/RightSideNav";
import SportSection from "../sportSection/SportSection";
import { useTheme } from "../context/ThemeContext";
import { CustomModal } from "../../components";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const baseUrl = process.env.REACT_APP_SERVER_URL;
const cardDataMob = [];

const FootBallNews = () => {
  const { fgColor, bgColor } = useTheme();

  const newsSearchRef = useRef();

  const sliderRef = useRef(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [totalSlides, setTotalSlides] = useState(0);
  const [selected, setSelected] = useState("");
  const [image, setImage] = useState("");

  const { data: profileData, refetch: refetchProfileData } =
    useFetchProfilesQuery();

  const userId = profileData?.user?._id;


  const {
    data: newsData,
    isLoading,
    refetch: refetchNewsData,
    error,
  } = useFetchGamesNewsQuery({
    userId,
    
  });
  useEffect(() => {
    const interval = setInterval(() => {
      refetchNewsData(); 
    }, 60000); 

    return () => clearInterval(interval); 
  }, [refetchNewsData]);
  const handleRefresh = async () => {
    setIsRefreshing(true); // Start rotation
    await refetchNewsData(); // Refetch the news data
    setIsRefreshing(false); // Stop rotation
  };
  const { data: universitiesData } = useFetchCollegesQuery();
  const collegeList = universitiesData?.university || [];

  const matchedCollege = collegeList.find(
    (college) => college.name === profileData?.user?.school_name
  );
  let fgColorCode;
  if (matchedCollege) {
    fgColorCode = matchedCollege.bg_color_code;
  } else {
  }
  const {
    data: singleCustomAdvertiser,
    refetch: refetchSingleCustomAdvertiser,
  } = useFetchSingleCustomAdvertiserQuery(profileData?.user?.school_name, {
    skip: !profileData?.user?.school_name,
  });

  const newsAdvertiser = singleCustomAdvertiser?.advertisers?.find(
    (ad) => ad.type === "news"
  );
  const [filteredNews, setFilteredNews] = useState([]);
  const [initialSelectedSports, setInitialSelectedSports] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const [showMore, setShowMore] = useState(false);

  const handleToggleDetails = () => {
    setShowMore((prevShowMore) => !prevShowMore);
  };

  const filterNews = () => {
    const newsToSearch = newsSearchRef.current.value.toLowerCase();
    if (newsToSearch === "") {
      setFilteredNews(newsData?.user_based_news || []);
    } else {
      const filtered = newsData?.user_based_news?.filter((card) =>
        card.title.toLowerCase().includes(newsToSearch)
      );
      setFilteredNews(filtered);
    }
  };
  useEffect(() => {
    if (newsData?.user_based_news) {
      let finalFilteredNews;

      if (!selected && !image) {
        finalFilteredNews = newsData.user_based_news;
      } else if (!selected && image) {
        finalFilteredNews = newsData.user_based_news.filter((newsItem) => {
          return (
            Array.isArray(newsItem.sports_tags) &&
            newsItem.sports_tags.includes(image)
          );
        });
      } else if (selected && !image) {
        finalFilteredNews = newsData.user_based_news.filter((newsItem) => {
          return newsItem.newsType === selected;
        });
      } else {
        const typeFilteredNews = newsData.user_based_news.filter((newsItem) => {
          return newsItem.newsType === selected;
        });

        finalFilteredNews = typeFilteredNews.filter((newsItem) => {
          return (
            Array.isArray(newsItem.sports_tags) &&
            newsItem.sports_tags.includes(image)
          );
        });
      }

      setFilteredNews(finalFilteredNews);
    }
  }, [newsData, selected, image]);

  useEffect(() => {
    if (profileData && profileData.user) {
      const { favorite_sports = [] } = profileData.user;
      const favoriteSports = favorite_sports[0]
        ? JSON.parse(favorite_sports[0])
        : [];
      const selectedSports = favoriteSports
        .map((athlete) => athlete.name)
        .slice(0, 3)
        .concat(Array(3).fill(""))
        .slice(0, 3);
      setInitialSelectedSports(selectedSports);
    } else {
    }
  }, [profileData]);

  useEffect(() => {
    if (sliderRef.current && sliderRef.current.innerSlider) {
      setTotalSlides(sliderRef.current.innerSlider.props.children.length);
    }
  }, [singleCustomAdvertiser]);
  const formatDate = (createdAt) => {
    const now = new Date();
    const createdDate = new Date(createdAt);
    const timeDiff = now - createdDate;

    const seconds = Math.floor(timeDiff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return `${days} day${days > 1 ? "s" : ""} ago`;
    } else if (hours > 0) {
      return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    } else {
      return `${seconds} second${seconds > 1 ? "s" : ""} ago`;
    }
  };
  return (
    <>
      <div className="card hiddenlg">
        <h4 className="broughttoyou card-body">Recruiting</h4>

        <SportSection
          selected={selected}
          setSelected={setSelected}
          image={image}
          setImage={setImage}
        />
      </div>
      {isLoading ? (
        <Skeleton height={900} />
      ) : (
        <>
          <div className="bg-white borderb mobresp">
            <h4 className="footballtext hiddensm">News</h4>

            <div className="mob-flex align-items-center justify-content-between News_searchContainer">
              <div className="mob-flex align-items-center justify-content-between News_searchContainer_gap">
                <div className="input-group search-bar">
                  <div className="input-group-prepend">
                    <CiSearch className="iconsearch" />
                  </div>
                  <input
                    type="text"
                    className="form-control searchfield "
                    placeholder="Search news here"
                    aria-label="Search"
                    ref={newsSearchRef}
                    onChange={filterNews}
                    style={{ borderRadius: "6px !important" }}
                  />
                </div>

                <div className="d-flex align-items-center justify-content-between News_searchContainer_gap">
                  <button
                    type="button"
                    className="News_All_btn"
                    style={{
                      backgroundColor: image === "" ? "#ce1126" : "white",
                      color: image === "" ? "white" : "#ce1126",
                    }}
                    onClick={() => setImage("")}
                  >
                    All
                  </button>
                  {initialSelectedSports.map((sport, index) => (
                    <button
                      key={index}
                      type="button"
                      className="News_All_btn"
                      style={{
                        backgroundColor: image === sport ? "#ce1126" : "white",
                        color: image === sport ? "white" : "#ce1126",
                      }}
                      onClick={() => setImage(sport)}
                    >
                      {sport || "N/A"}{" "}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end mt-2">
            <img
    className={`refresh-icon ${isRefreshing ? "rotating" : ""}`}
  width="20"
  height="20"
  src="https://img.icons8.com/material-outlined/24/reboot.png"
  alt="reboot"
  onClick={handleRefresh}
/>
            </div>
            
          </div>
        
          <div className="bg-white">
            <div>
              <div
                className="row News_Main "
                style={{
                  scrollbarColor: bgColor
                    ? `${bgColor} #f1f1f1`
                    : "#704fe6 #f1f1f1",
                  scrollbarWidth: "thin",
                }}
              >
                {filteredNews.length === 0 ? (
                  <div className="News_No_available">No news available</div>
                ) : (
                  [...filteredNews]
                    .sort(
                      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                    )
                    .map((card, index) => (
                      <div className="card22">
                        <div className="News_filter_MainDiv">
                          <div className="News_filter_MainDiv_cont">
                            <div>
                              <h6 className="News_filter_Schoolname">
                                {card.schoolName}
                              </h6>
                            </div>
                          </div>

                          <h5 className="News_filter_title">
                            {" "}
                            <a
                              href={card.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="News_filter_URLLink"
                            >
                              {card.title}
                            </a>
                          </h5>

                          <p
                            className="concoursepara"
                            style={{
                              display: "-webkit-box",
                              WebkitLineClamp: showMore ? "none" : 3,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              height: showMore ? "auto" : "auto",
                              lineHeight: "1.5em",
                              margin: 0,
                              cursor: "pointer",
                            }}
                            onClick={handleToggleDetails}
                          >
                            {card.details}
                          </p>

                          {showMore && (
                            <div>
                              <p>{card.additionalDetails}</p>{" "}
                            </div>
                          )}

                          <a
                            href={card.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="News_filter_detailsURL"
                          >
                            View Details
                            <img
                              width="18"
                              height="18"
                              src="https://img.icons8.com/fluency-systems-filled/48/external-link.png"
                              alt="external-link"
                            />
                          </a>

                          <p className="News_filter_CreatedAt">
                            {formatDate(card?.createdAt)}
                          </p>
                        </div>
                      </div>
                    ))
                )}
              </div>

              <div className="hiddenlg hiddensm">
                {cardDataMob.map((card, index) => (
                  <div className="card mb-3" key={index}>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-7">
                          <div className="d-flex align-items-center mb-3">
                            <FadeInAnimation>
                              <img
                                src={card.profileImg}
                                className="img-fluid pimage"
                                alt="Profile"
                              />
                            </FadeInAnimation>
                            <div className="profileinfo">
                              <LeftSideAnimation x={-100}>
                                <h6>{card.profileName}</h6>
                              </LeftSideAnimation>
                              <LeftSideAnimation x={-100}>
                                <p>
                                  <Link to={card.profileUrl}>
                                    {card.profileUrl}
                                  </Link>
                                </p>
                              </LeftSideAnimation>
                            </div>
                          </div>
                          <LeftSideAnimation x={-100}>
                            <h1 className="mainheadingcard">{card.title}</h1>
                          </LeftSideAnimation>
                          <LeftSideAnimation x={-100}>
                            <p className="maincardpara">{card.description}</p>
                          </LeftSideAnimation>
                        </div>
                        <div className="col-5">
                          <LeftSideAnimation x={100}>
                            <img
                              src={card.imgSrc}
                              className="img-fluid w-100"
                              alt="Card"
                            />
                          </LeftSideAnimation>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
      <div className="bg-white row hiddenlg">
        <div className="col">
          <LeftSideAnimation x={-100}>
            {newsAdvertiser ? (
              <a
                href={newsAdvertiser.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  key={newsAdvertiser._id}
                  src={`${baseUrl}/${newsAdvertiser.businessLogo}`}
                  alt={newsAdvertiser.businessName}
                  className="News_BusinessImage broughtimage img-fluid px-3"
                />
              </a>
            ) : (
              <h6 className="No_news_ads">No News Ads available.</h6>
            )}
          </LeftSideAnimation>
        </div>
        <div className="col">
          <h4 className="broughttoyou2 mb-2 p-0">CSFA POLL - SURVEY</h4>
          <RightSideNav />
        </div>
      </div>

      <CustomModal isOpen={show} onClose={handleClose}>
        <div className="News_Sports_MainDiv">
          <h3>Sport Details</h3>
          <p className="neilsonmodaltext">
            We’d like to thank [NEILSON] for sponsoring this weeks raffle :
          </p>
          <p className="neilsonmodaltext">
            2 Ticket to the Ole Miss vs oklahoma Game
          </p>
          <div className="table-responsive py-3">
            <table style={{ width: "100%", tableLayout: "fixed" }}>
              <tbody>
                <tr>
                  <td style={{ width: "25%", textAlign: "left" }}>Game</td>
                  <td style={{ width: "15%", textAlign: "center" }}>:</td>
                  <td style={{ width: "65%" }}>Ole Miss vs oklahoma</td>
                </tr>
                <tr>
                  <td style={{ width: "25%", textAlign: "left" }}>Date</td>
                  <td style={{ width: "15%", textAlign: "center" }}>:</td>
                  <td style={{ width: "65%" }}>Oct 10, 2024</td>
                </tr>
                <tr>
                  <td style={{ width: "25%", textAlign: "left" }}>Location</td>
                  <td style={{ width: "15%", textAlign: "center" }}>:</td>
                  <td style={{ width: "65%" }}>Vaught Hemingway</td>
                </tr>
                <tr>
                  <td style={{ width: "25%", textAlign: "left" }}>
                    Seat Location
                  </td>
                  <td style={{ width: "15%", textAlign: "center" }}>:</td>
                  <td style={{ width: "65%" }}>40' yard line (Section H)</td>
                </tr>
                <tr>
                  <td style={{ width: "25%", textAlign: "left" }}>
                    Provided by
                  </td>
                  <td style={{ width: "15%", textAlign: "center" }}>:</td>
                  <td style={{ width: "65%" }}>Neilson (On the square)</td>
                </tr>
                <tr>
                  <td style={{ width: "45%", textAlign: "left" }}>Format</td>
                  <td style={{ width: "10%", textAlign: "center" }}>:</td>
                  <td style={{ width: "45%" }}>
                    Electronic to your member TDX Page
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <img
            src="/images/neilson.png"
            alt="Neilson"
            className="img-fluid neilsonImageModal"
          />
          <p className="modaltextFooter">
            We are also offering a 20% discount to CSFA members on our latest
            arrival of Ole Miss Shorts! Just click the image above to see more!
          </p>
        </div>
      </CustomModal>
    </>
  );
};

export default FootBallNews;
